import { useAtom } from '@reatom/npm-react'
import styled from 'styled-components'

import { pairViewAtom } from '../../../atoms'

import type { ClassNameProps, StyleProps } from '@root/shared/react'

type TradingPairHeaderToggleProps = {}

export const TradingPairHeaderToggle: React.FC<
  TradingPairHeaderToggleProps
> = () => {
  const [pairView] = useAtom(pairViewAtom)

  return (
    <Root type="button">
      <ArrowUp
        style={{
          color:
            pairView === 'chart'
              ? 'var(--background-8)'
              : 'var(--background-12)',
        }}
      />
      <ArrowDown
        style={{
          color:
            pairView === 'details'
              ? 'var(--background-8)'
              : 'var(--background-12)',
        }}
      />
    </Root>
  )
}

const Root = styled.button`
  all: unset;
  cursor: pointer;
  display: grid;
  gap: 8px;
  width: 23px;
  height: 100%;

  justify-content: center;
  align-content: center;
  border-inline-start: 1px solid var(--background-3);
`

const ArrowUp = ({ className, style }: ClassNameProps & StyleProps) => {
  return (
    <svg
      width="9"
      height="9"
      viewBox="0 0 9 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <g clipPath="url(#clip0_4254_25072)">
        <rect
          width="6.41452"
          height="0.801815"
          rx="0.400908"
          transform="matrix(-0.701533 0.712637 0.701533 0.712637 4.5 0)"
          fill="currentColor"
        />
        <rect
          width="6.41452"
          height="0.801815"
          rx="0.400908"
          transform="matrix(0.701533 0.712637 0.701533 -0.712637 3.9375 0.572266)"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_4254_25072">
          <rect width="9" height="9" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

const ArrowDown = styled(ArrowUp)`
  transform: rotate(180deg);
`
